<div class="bg-white max-w-96 rounded-lg p-4 relative">
  <img src="/assets/svg/coworkrz.svg" alt="Coworkrz" />
  <h1 class="my-5 font-medium text-2xl">
    Please sign in with your Google account to continue
  </h1>
  <div class="g_id_signin"></div>
  @if (errors) {
  <div class="text-red-500 text-sm my-5">{{ errors }}</div>
  } @if (loading) {
  <div
    class="absolute -bottom-[1px] left-4 right-4 h-0.5 overflow-hidden rounded-full"
  >
    <ui-progress-bar></ui-progress-bar>
  </div>
  }
</div>
